import React from 'react';
import { v4 as uuidv4 } from "uuid";

import {
  IonList,
  IonItem,
  IonContent
} from '@ionic/react'

import { Student, CANDIDATES } from '../data/candidates';
type Props = {
  dismiss: (c: Student) => void;
}

const StudentList: React.FC<Props> = ({ dismiss }) => {
  return (
    <IonContent scrollY={true}>
      <IonList>
        { CANDIDATES.map((entry) => (
          <IonItem onClick={() => dismiss(entry)} key={uuidv4()} style={{ cursor: "pointer" }}>
            {`${entry.last}, ${entry.initial}.`}
          </IonItem>
        ))}
      </IonList>

    </IonContent>
      
  );
};

export default StudentList;

